import * as React from 'react';

import {AlertBox} from 'shells/alert-box/alert-box';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {EditionCreationFooter} from '../edition-creation-footer';

import {ComparisonFieldsCheckboxGroup} from './comparison-fields-checkbox-group';

export const SUBJECT = 'subject';
export const PREVIEW_TEXT = 'previewText';
export const CONTENT = 'content';

type Props = {
    setShowComparisonFieldsSelectModal: (arg1: boolean) => void;
    userFacingNoun: string;
    fieldsToCompare: string[];
    setFieldsToCompare: (arg1: string[]) => void;
    handleEditionCreation: (arg1: string) => void;
    isCreating: boolean;
};

export function ComparisonFieldsSelectModal(props: Props) {
    return (
        <AlertBox onClose={() => props.setShowComparisonFieldsSelectModal(false)} maxWidth={562}>
            <div style={{padding: '16px 8px'}}>
                <ModalHeader>What are you A/B testing?</ModalHeader>
                <StackLegacy spacing={16}>
                    <ModalBody>
                        Select one or more variables to compare between both versions of your
                        message:
                    </ModalBody>
                    <div className='mb-16'>
                        <ComparisonFieldsCheckboxGroup
                            fieldsToCompare={props.fieldsToCompare}
                            setFieldsToCompare={props.setFieldsToCompare}
                        />
                    </div>
                    <EditionCreationFooter
                        onCancel={() => props.setShowComparisonFieldsSelectModal(false)}
                        onCreate={() => props.handleEditionCreation('Untitled A/B test')}
                        userFacingNoun={props.userFacingNoun}
                        isCreating={props.isCreating}
                    />
                </StackLegacy>
            </div>
        </AlertBox>
    );
}
